import { ReactNode } from 'react';
import { FlexGrid, Typography, Card } from "@albo-ui/core";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SectionItem from './SectionItem';

export type SectionHeaderProps = {
  	title: string;
	sectionName?: string;
	data?: any;
	columns?: any;
	icon?: ReactNode;
	open?: boolean
	checked?: any;
	subSections?: any;
	onSearch: (type: string) => void;
	onSetClean?: (type: boolean) => void;
	onDisplayImage?: (data: any) => void;
	updateSectionStatusLead?: (data: any) => void;
};

const SectionHeader = ({ title, icon, columns, data, sectionName, open, checked, subSections, onSearch, onSetClean, onDisplayImage, updateSectionStatusLead }: SectionHeaderProps) => {
	const onShowInfo  = () => {
		!open && onSearch(sectionName)
		open && onSetClean(false)
	}

  	return (
		<FlexGrid container style={{paddingBottom: 16}}>
		<Card
			padding={2} fullWidth flexDirection="column" alignItems="stretch" justifyContent="space-between"
			style={{ borderColor: checked ? "#32cc25" : "#ed6c02", height: !open ? "70px" : "auto" }}
		>
			<FlexGrid container item direction="column" spacing={1}>
				<FlexGrid item style={{paddingBottom: "0.8rem"}}>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
						{icon}{title}{checked ? <CheckCircleIcon color='success' sx={{ml: 2}} /> : <ErrorIcon color='warning'  sx={{ml: 2}}/>}
					</Typography>
						{open ?
							<KeyboardArrowUpIcon sx={{ float: "right", cursor: "pointer"}} onClick={onShowInfo}/>
							:							
							<KeyboardArrowDownIcon sx={{ float: "right", cursor: "pointer"}} onClick={onShowInfo}/>
						}
				</FlexGrid>
				{open && Array.isArray(data) && data.length === 0 &&
					<FlexGrid item style={{paddingBottom: "0.8rem"}}>
						<Typography variant="paragraph" >
							El Lead no posee información asociada.
						</Typography>
					</FlexGrid>
				}
				{open && Array.isArray(data) && sectionName === "ADDITIONAL_INFORMATION" &&
					columns?.map((item, i) => {
						return data.map((options, index) =>  options["section"] === item.section && <SectionItem key={index-i} data={data} item={item} options={options} index={index} i={i} onDisplayImage={onDisplayImage} subSections={subSections} updateSectionStatusLead={updateSectionStatusLead}/>)
					})
				}
				{open && Array.isArray(data)  && sectionName !== "ADDITIONAL_INFORMATION" && data.map((options, index) => {
					return columns?.map((item, i) => {
						return <SectionItem key={index-i} data={data} item={item} options={options} index={index} i={i} onDisplayImage={onDisplayImage} subSections={subSections} updateSectionStatusLead={updateSectionStatusLead}/>
					})
				})}
				{open && !Array.isArray(data) && columns?.map((item, index) => {
					return <SectionItem key={index} data={data} item={item} index={index} onDisplayImage={onDisplayImage} subSections={subSections} updateSectionStatusLead={updateSectionStatusLead}/>
				
				})}			
			</FlexGrid>
		</Card>
		</FlexGrid>
  	);
};

export default SectionHeader;
